import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import {Card, CardTitle, CardText} from 'material-ui/Card';
import { connect } from 'react-redux'
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import CircularProgress from 'material-ui/CircularProgress';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {
  checkout
} from '../Otop/actions'
import language from '../../config/language'

class Contact extends Component {
  static defaultProps = {
    loading: false,
    error: '',
    sendSuccess: false
  }
  state = {
    name: '',
    tel: '',
    email: '',
    address: '',
    error: '',
    modalComplease: false,
    modalError: false,
  }
  onSubmit = (event) => {
    event.preventDefault();
    const {
      name,
      tel,
      email,
      address,
    } = this.state
    this.props.checkout({
      name,
      tel,
      email,
      address,
    })
    // this.props.history.push('/home')
  }
  onChange(e, newValue, type) {
    this.setState({
      [type]: newValue
    })
  }
  handleClose = (type) => {
    this.setState({[type]: false}, () => {
      if (this.props.sendSuccess) {
        this.props.history.push('/home')
      }
    });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.sendSuccess !== this.props.sendSuccess && nextProps.sendSuccess === true) {
      this.setState({
        modalComplete: true
      })
    }
    if (nextProps.error !== this.props.error && nextProps.error) {
      this.setState({
        modalError: true
      })
    }
  }
  render() {
    const {
      backtohome,
      ok,
      sendcontectsuccess,
      contactService,
      contactTitle,
      sendContactSuccess,
      sendContactFailure,
      forms,
      textTitleLoading,
      textSuccess
    } = language[this.props.lang].contact
    const actions = [
      <FlatButton
        label={backtohome}
        primary={true}
        onClick={() => this.handleClose('modalComplete')}
      />,
    ]
    const actionsError = [
      <FlatButton
        label={ok}
        primary={true}
        onClick={() => this.handleClose('modalError')}
      />,
    ]
    return (
      <div>
        <AppBar
          title={sendcontectsuccess}
          iconElementLeft={
            <IconButton
              onClick={() => this.props.history.goBack()}
            >
              <i className="material-icons">arrow_back</i>
            </IconButton>
          }
          style={{ backgroundColor: '#75b41c' }}
        />
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardTitle title={contactTitle}/>
            <CardText>
            <TextField
              hintText={forms.name.hintText}
              floatingLabelText={forms.name.floatingLabelText}
              fullWidth
              name="name"
              onChange={(e, newValue)=> this.onChange(e, newValue, 'name')}
              required                                
            />
            <br />
            <TextField
              hintText={forms.tel.hintText}
              floatingLabelText={forms.tel.floatingLabelText}
              fullWidth
              name="tel"
              type="number"
              onChange={(e, newValue)=> this.onChange(e, newValue, 'tel')}
              required
              maxLength={10}                  
            />
            <br />
            <TextField
              hintText={forms.email.hintText}
              floatingLabelText={forms.email.floatingLabelText}
              fullWidth
              name="email"
              type="email"
              onChange={(e, newValue)=> this.onChange(e, newValue, 'email')}
              required
              autocomplete="off"
            />
            <br />
            <TextField
              floatingLabelText={forms.address.floatingLabelText}
              multiLine={true}
              rows={5}
              fullWidth
              name="address"
              onChange={(e, newValue)=> this.onChange(e, newValue, 'address')}
              required
            />
            <br />
            <br />
            <br />
            <RaisedButton
              label={forms.button.label}
              primary={true}
              fullWidth
              type="subbmit"
            />
            </CardText>
          </Card>
        </form>
        <Dialog
          title={textTitleLoading}
          modal={false}
          open={this.props.loading}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress />            
          </div>
        </Dialog>
        <Dialog
          title={sendContactSuccess}
          actions={actions}
          modal={false}
          open={this.state.modalComplete}
          onRequestClose={() => this.handleClose('modalComplete')}
        >
          {textSuccess}
        </Dialog>
        <Dialog
          title={sendContactFailure}
          actions={actionsError}
          modal={false}
          open={this.state.modalError}
          onRequestClose={() => this.handleClose('modalError')}
        >
          {this.props.error}
        </Dialog>
      </div>
    )
  }
}

export default connect(
  state => ({
    loading: state.otop.cart.loading,
    error: state.otop.cart.error,
    sendSuccess: state.otop.cart.sendSuccess,
    lang: state.lang
  }), {
    checkout
  }
)(Contact)



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js